import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';

/**
 * 母版编辑 UI 数据和 sdk 数据的转换计算
 */
export default class MasterLayoutUtils {
    /**
     * 根据 masterList 获取拍平的 layoutList
     * 拍平的 layoutList 即 UI 显示的版式列表源数据(不包括母版)
     */
    public static getUiLayoutList(masterList: Array<IMasterModel>): Array<ILayoutModel> {
        return masterList?.reduce((pre: ILayoutModel[], cur) => {
            const masterLayoutList: ILayoutModel[] = cur.layoutList.slice(0, cur.layoutList.length);
            return pre.concat(masterLayoutList);
        }, []);
    }

    /**
     * 根据 masterList 获取拍平的 master-layout-list
     * 拍平的 master-layout-list 即 UI 显示的版式列表源数据(包括母版)
     */
    public static getUiMasterLayoutList(masterList: Array<IMasterModel>): Array<IMasterModel | ILayoutModel> {
        return masterList?.reduce((pre: Array<IMasterModel | ILayoutModel>, cur) => {
            const masterArr = [cur];
            const masterLayoutList: ILayoutModel[] = cur.layoutList.slice(0, cur.layoutList.length);
            return pre.concat([...masterArr, ...masterLayoutList]);
        }, []);
    }

    /**
     * 根据当前选中的版式获取 sdk 版式列表中对应的插入索引
     * @param sdkLayoutList presentation/sdk 里的版式列表
     * @param curSlide 当前选中页面
     * @returns 插入索引
     */
    public static getIndexFromLayout(sdkLayoutList: Array<ILayoutModel>, curSlide: ILayoutModel): number {
        const curLayoutId = curSlide.id;
        const sdkIndex = sdkLayoutList.findIndex(i => i.id === curLayoutId);
        return sdkIndex + 1;
    }

    /**
     * 根据当前选中的母版获取 sdk 版式列表中对应的插入索引
     * @param masterList 母版列表
     * @param sdkLayoutList presentation/sdk 里的版式列表
     * @param curSlide 当前选中页面
     * @returns 插入索引
     */
    public static getIndexFromMaster(
        masterList: Array<IMasterModel>,
        sdkLayoutList: Array<ILayoutModel>,
        curSlide: IMasterModel,
    ): number {
        return 0;
    }

    /**
     * 根据当前选中的间隙获取 sdk 版式列表中对应的插入索引
     * @param masterList 母版列表
     * @param sdkLayoutList presentation/sdk 里的版式列表
     * @param curSlide 当前选中页面
     * @returns 插入索引
     */
    public static getIndexFromGap(
        masterList: Array<IMasterModel>,
        sdkLayoutList: Array<ILayoutModel>,
        curSlide: ILayoutModel | IMasterModel,
    ): number {
        if (curSlide.isLayout) {
            return MasterLayoutUtils.getIndexFromLayout(sdkLayoutList, curSlide as ILayoutModel);
        }
        if (curSlide.isMaster) {
            return MasterLayoutUtils.getIndexFromMaster(masterList, sdkLayoutList, curSlide as IMasterModel);
        }
        return 0;
    }

    /**
     * 从 sdk 数据的版式索引获取对应的 ui 数据的版式索引
     * @param uiLayoutList
     * @param sdkLayoutList
     * @param sdkIndex
     */
    public static getUiIndexFromSdkIndex(
        uiLayoutList: Array<ILayoutModel>,
        sdkLayoutList: Array<ILayoutModel>,
        sdkIndex: number,
    ): number | undefined {
        if (sdkIndex < 0) {
            return;
        }
        const layoutId = sdkLayoutList[sdkIndex].id;
        return uiLayoutList.findIndex(i => i.id === layoutId);
    }

    /**
     * 从 ui 数据的版式索引获取对应的 sdk 数据的版式索引
     * @param uiLayoutList
     * @param sdkLayoutList
     * @param sdkIndex
     */
    public static getSdkIndexFromUiIndex(
        uiLayoutList: Array<ILayoutModel>,
        sdkLayoutList: Array<ILayoutModel>,
        uiIndex: number,
    ): number | undefined {
        if (uiIndex < 0) {
            return;
        }
        const layoutId = uiLayoutList[uiIndex].id;
        return sdkLayoutList.findIndex(i => i.id === layoutId);
    }
}
